import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { apiDocStyles } from '../styles/apiDocStyles';

const TableOfContents = ({ endpoint }) => {
  const { t } = useTranslation();
  const [activeSection, setActiveSection] = useState('overview');

  const sections = useMemo(() => [
    { id: 'overview', label: t('apiDoc.toc.overview') },
    { id: 'request', label: t('apiDoc.toc.request') },
    { id: 'response', label: t('apiDoc.toc.response') },
    { id: 'example', label: t('apiDoc.toc.example') },
  ], [t]);

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections.map(section => ({
        id: section.id,
        element: document.getElementById(section.id),
      }));

      for (let i = sectionElements.length - 1; i >= 0; i--) {
        const { id, element } = sectionElements[i];
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150) {
            setActiveSection(id);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sections]);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 100;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  if (!endpoint) return null;

  return (
    <aside style={apiDocStyles.toc}>
      <div style={apiDocStyles.tocTitle}>
        {t('apiDoc.toc.title')}
      </div>
      <nav>
        {sections.map(section => (
          <button
            key={section.id}
            style={{
              ...apiDocStyles.tocItem(activeSection === section.id),
              border: 'none',
              background: 'none',
              width: '100%',
            }}
            onClick={() => scrollToSection(section.id)}
            onMouseEnter={(e) => {
              if (activeSection !== section.id) {
                e.currentTarget.style.color = '#1A62EA';
              }
            }}
            onMouseLeave={(e) => {
              if (activeSection !== section.id) {
                e.currentTarget.style.color = '#6b7280';
              }
            }}
          >
            {section.label}
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default TableOfContents;
